import Swiper, { Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([ Autoplay ])

const sliderContainer = document.querySelector('#header-share-slider .swiper-container')

if (sliderContainer) {
    const headerSlider = new Swiper(sliderContainer, {
        direction: 'horizontal',
        autoplay: true,
        delay: 4000,
        loop : true,
        slidesPerView: 1,
    })
}

//Menu toggle
const headerTabletMenuButton = document.querySelector('.header-tablet__menu-burger'),
navigationCloseButton = document.querySelector('.navigation-tablet__close'),
pageBodyHeaderContainer = document.querySelector('.page__body-header')

if (headerTabletMenuButton && navigationCloseButton && pageBodyHeaderContainer) {
    const handleToggle = () => {
        pageBodyHeaderContainer.classList.toggle('page__body-header_show')
    }

    headerTabletMenuButton.addEventListener('click', handleToggle)

    navigationCloseButton.addEventListener('click', handleToggle)
}